import { Box, Typography, useTheme } from "@mui/material";
import NavBackButton from "../../../../components/NavBackButton";

export default function MobileHeader() {
  const theme = useTheme();
  return (
    <Box
      sx={{
        position: "fixed",
        maxWidth: "450px",
        top: "0px",
        width: "100%",
        zIndex: 150,
        backgroundColor: theme.palette.bgColor.grey100,
        transition: "box-shadow 500ms",
        display: "flex",
        // alignItems: "center",
        justifyContent: "space-between",
        paddingY: "12px",
        paddingX: "8px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <NavBackButton />
        <Typography
          sx={{
            fontWeight: "700",
            color: "secondary.main",
          }}
        >
          اعلان‌ها
        </Typography>
      </Box>

      {/* <CustomButton
        onClick={() => navigate("../settings")}
        flexDirection="row"
        title="تنظیمات اطلاع‌رسانی"
        justifyContent="center"
        rippleColor={theme.palette.secondary.main}
        bgColor={theme.palette.secondary[50]}
        textColor="secondary.main"
        fSize="14px"
        borderColor="secondary.main"
        fWeight="700"
        px="10px"
        py="6px"
        borderRadius="10px"
        icon1={<SettingsIcon color={theme.palette.secondary.main} />}
      /> */}
    </Box>
  );
}
